import {
   GET_ELOG_LIST_SUCCESS,
   GET_FILES_URL_SUCCESS,
   GET_ELOG_LIST_FAIL,
   GET_PRE_SIGNED_ELOG_LIST_SUCCESS,
   GET_PRE_SIGNED_ELOG_LIST_FAIL,
   GET_PRE_SIGNED_ELOG_CONFIG_SUCCESS,
   GET_COMPANY_SUCCESS
} from "../actions";

const initialState = {
   elogList: [],
   preSignedElogList: [],
   fileURL: null,
   preSignedElogConfig: null,
   company: null
};

export default function (state = initialState, action) {
   switch (action.type) {
      case GET_ELOG_LIST_SUCCESS:
         return Object.assign({}, state, {
            elogList: action.payload.response.data.results
         });
      case GET_ELOG_LIST_FAIL:
         return Object.assign({}, state, {
            elogList: []
         });
      case GET_FILES_URL_SUCCESS:
         return Object.assign({}, state, {
            fileURL: action.payload.response.data
         });
      case GET_PRE_SIGNED_ELOG_LIST_SUCCESS:
         return Object.assign({}, state, {
            preSignedElogList: action.payload.response.data.results
         });
      case GET_PRE_SIGNED_ELOG_LIST_FAIL:
         return Object.assign({}, state, {
            preSignedElogList: []
         });
      case GET_PRE_SIGNED_ELOG_CONFIG_SUCCESS:
         return Object.assign({}, state, {
            preSignedElogConfig: action.payload.data.config
         });
      case GET_COMPANY_SUCCESS:
         return Object.assign({}, state, {
            company: action.payload.data.client[0]
         });

      default:
         return state;
   }
}
